import React from 'react';
import modules from 'modules'
import { theme } from 'assets/lib';
import { PortalLink } from 'components/atoms'
import {
  Theme, ThemeProvider, ConfigProvider, InjectIntlContext
} from '@uaveiro/ui';
import { PORTAL_WWW, PORTAL_IMAGES_ENDPOINT, PORTAL_API } from 'services/constants';
import { IntlProvider, FormattedMessage } from 'react-intl';
import pt from 'data/messages/pt'

const messages = { pt }
export const withPortalProviders = (WrappedComponent, props) => (
  <IntlProvider locale="pt" messages={messages.pt}>
    <ThemeProvider theme={Theme}>
      <InjectIntlContext>
        <ConfigProvider
          config={{
            imageAPI: PORTAL_IMAGES_ENDPOINT,
            portalWWW: PORTAL_WWW,
            portalAPI: PORTAL_API,
          }}
          components={{
            link: PortalLink,
            formattedMessage: FormattedMessage,
            isIE: () => false,
          }}
        >
          <WrappedComponent {...props} theme={Theme} />
        </ConfigProvider>
      </InjectIntlContext>
    </ThemeProvider>
  </IntlProvider>
);

// Theme not coming from the library
export const withPortalThemeLegacy = (WrappedComponent, props) => (
  <ThemeProvider theme={theme}>
    <WrappedComponent {...props} />
  </ThemeProvider>
);

export const isHiddenModule = (name) => {
  const modulesKeys = Object.keys(modules)
  const module = modulesKeys.find(key => key === name)
  if (!module) return false
  const moduleProps = modules[module]
  return (moduleProps.options && moduleProps.options.hidden) || false
}

// used to check if is an empty page
// removes SEO and only then checks if it has more modules (SEO should not count)
export const computeHasModules = (pageData) => {
  if (!pageData) return false
  if (pageData.lenght === 0) return false

  const pageWithoutSeo = pageData.reduce((page, organism) => {
    if (organism.name === 'SEO') return page
    return [...page, organism]
  }, [])
  return pageWithoutSeo.length > 0
}
